import List from '../../components/List/List';
import { categories } from '../../utils/cardInfo';

const FundingPage = () => {
  return (
    <List
      category={'grants'}
      heading={'Funding'}
      cardHeader={categories.grants.cardHeader}
      icons={categories.grants.icons}
      dotColor={categories.grants.dotColor}
    />
  );
};

export default FundingPage;
